
import { VSelect } from 'vuetify/lib';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({ name: 'd4y-select' })
export default class D4ySelect extends VSelect {
  @Prop({ default: false })
  rounded!: boolean;
  @Prop({ default: true })
  outlined!: boolean;
  @Prop({ default: true })
  dense!: boolean;
}
